/** Side margins the panel keeps from the viewport edge (2rem), mirrors the CSS max-width clamp. */
const MARGIN_X = 32;
const DEFAULT_W = 420;
const EXPANDED_W = 640;

/**
 * Whether expanding changes the panel width at all. On a phone both widths are clamped to the same
 * screen width, so the control would do nothing. `null` = viewport not measured yet (assume room).
 */
export function expandHasRoom(viewportWidth: number | null): boolean {
  if (viewportWidth === null) return true;
  const max = viewportWidth - MARGIN_X;
  return Math.min(EXPANDED_W, max) > Math.min(DEFAULT_W, max);
}
